import React from "react";
import Badge from "../../components/badge";
import ReadOnlyField from "../../components/readOnlyField";
import ReadOnlyPhoneField from "../../components/readOnlyPhoneField";
import emailIcon from "../../icons/popup/email.svg";
import calendarIcon from "../../icons/users/calender.svg";
import clockIcon from "../../icons/users/colck.svg";
import type { BadgeProps } from "../../components/badge";

type BadgeVariant = BadgeProps["variant"];

interface AccountDetailsSectionProps {
  title: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  status?: string;
  dateCreated?: string;
  lastLogin?: string;
  statusBadgeVariant?: BadgeVariant;
  statusLabel?: string;
  labels: {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    status: string;
    dateCreated: string;
    lastLogin: string;
  };
}

const AccountDetailsSection: React.FC<AccountDetailsSectionProps> = ({
  title,
  firstName,
  lastName,
  email,
  phoneNumber,
  status,
  dateCreated,
  lastLogin,
  statusBadgeVariant,
  statusLabel,
  labels,
}) => {
  const hasStatus = Boolean(status || statusLabel);

  return (
    <div className="flex flex-col lg:flex-row gap-4 lg:gap-6">
      <div className="lg:w-48 flex-shrink-0">
        <h2 className="text-sm font-medium text-[#414651] mb-4 lg:mb-0">
          {title}
        </h2>
      </div>
      <div className="flex-1 rounded-xl border border-[#E9EAEB] bg-white shadow-sm">
        <div className="px-4 sm:px-6 py-6">
          <div className="grid gap-4 sm:gap-6">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <ReadOnlyField label={labels.firstName} value={firstName} />
              <ReadOnlyField label={labels.lastName} value={lastName} />
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <ReadOnlyField
                label={labels.email}
                value={email}
                icon={
                  <img src={emailIcon} alt="" className="h-4 w-4 opacity-70" />
                }
              />
              <ReadOnlyPhoneField
                label={labels.phoneNumber}
                value={phoneNumber}
              />
            </div>

            <ReadOnlyField
              label={labels.status}
              value={
                hasStatus ? (
                  <Badge
                    variant={statusBadgeVariant}
                    size="sm"
                    className="!rounded-sm"
                  >
                    {statusLabel}
                  </Badge>
                ) : undefined
              }
            />

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <ReadOnlyField
                label={labels.dateCreated}
                value={dateCreated}
                icon={<img src={calendarIcon} alt="" className="opacity-70" />}
              />
              <ReadOnlyField
                label={labels.lastLogin}
                value={lastLogin}
                icon={<img src={clockIcon} alt="" className="opacity-70" />}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountDetailsSection;
